import {
  PRODUCT_ALLOCATED_PENSION_CASH,
  PRODUCT_ALLOCATED_PENSION_FIXED,
  PRODUCT_ANNUITY_FIXED_TERM,
  PRODUCT_ANNUITY_LIQUID_LIFETIME,
  PRODUCT_ANNUITY_LIFETIME,
  PRODUCT_CARE_PLUS,
  PRODUCT_SUPERANNUATION_FUND_CASH,
  PRODUCT_SUPERANNUATION_FUND_FIXED,
  PRODUCT_TERM_ALLOCATED_PENSION_CASH,
  PRODUCT_TERM_ALLOCATED_PENSION_FIXED,
  PRODUCT_UNIT_TRUST,
  ACCOUNT_NUMBER,
  BALANCE,
  BALANCE_CLOSED,
  DATE_CLOSED,
  MATURITY_DATE,
  NEXT_PAYMENT,
  NEXT_PAYMENT_CLOSED,
  PAYMENT_DATE,
  POLICY_NUMBER,
  TERM,
  UNIT_PRICE,
  UNIT_PRICE_CLOSED,
  UNITS,
  UNITS_CLOSED,
} from './constants';

export const overviewMap = {};

// AllocatedPensionCash
overviewMap[PRODUCT_ALLOCATED_PENSION_CASH] = {};
overviewMap[PRODUCT_ALLOCATED_PENSION_CASH].active = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: BALANCE,
};
overviewMap[PRODUCT_ALLOCATED_PENSION_CASH].closed = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: BALANCE_CLOSED,
};

// AllocatedPensionFixed
overviewMap[PRODUCT_ALLOCATED_PENSION_FIXED] = {};
overviewMap[PRODUCT_ALLOCATED_PENSION_FIXED].active = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: MATURITY_DATE,
};
overviewMap[PRODUCT_ALLOCATED_PENSION_FIXED].closed = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: MATURITY_DATE,
};

// AnnuityFixedTerm
overviewMap[PRODUCT_ANNUITY_FIXED_TERM] = {};
overviewMap[PRODUCT_ANNUITY_FIXED_TERM].active = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: MATURITY_DATE,
};
overviewMap[PRODUCT_ANNUITY_FIXED_TERM].closed = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: MATURITY_DATE,
};

// AnnuityLiquidLifetime
overviewMap[PRODUCT_ANNUITY_LIQUID_LIFETIME] = {};
overviewMap[PRODUCT_ANNUITY_LIQUID_LIFETIME].active = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: TERM,
};
overviewMap[PRODUCT_ANNUITY_LIQUID_LIFETIME].closed = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: TERM,
};

// AnnuityLifetime
overviewMap[PRODUCT_ANNUITY_LIFETIME] = {};
overviewMap[PRODUCT_ANNUITY_LIFETIME].active = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: TERM,
};
overviewMap[PRODUCT_ANNUITY_LIFETIME].closed = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: TERM,
};

// CarePlus
overviewMap[PRODUCT_CARE_PLUS] = {};
overviewMap[PRODUCT_CARE_PLUS].active = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: TERM,
};
overviewMap[PRODUCT_CARE_PLUS].closed = {
  f1: POLICY_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: TERM,
};

// SupperannuationFundCash
overviewMap[PRODUCT_SUPERANNUATION_FUND_CASH] = {};
overviewMap[PRODUCT_SUPERANNUATION_FUND_CASH].active = {
  f1: ACCOUNT_NUMBER,
  f2: BALANCE,
};
overviewMap[PRODUCT_SUPERANNUATION_FUND_CASH].closed = {
  f1: ACCOUNT_NUMBER,
  f2: BALANCE_CLOSED,
};

// SupperannuationFundFixed
overviewMap[PRODUCT_SUPERANNUATION_FUND_FIXED] = {};
overviewMap[PRODUCT_SUPERANNUATION_FUND_FIXED].active = {
  f1: ACCOUNT_NUMBER,
  f2: MATURITY_DATE,
};
overviewMap[PRODUCT_SUPERANNUATION_FUND_FIXED].closed = {
  f1: ACCOUNT_NUMBER,
  f2: MATURITY_DATE,
};

// TermAllocatedPensionCash
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH] = {};
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH].active = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: BALANCE,
};
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_CASH].closed = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: BALANCE_CLOSED,
};

// TermAllocatedPensionFixed
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED] = {};
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED].active = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT,
  f3: PAYMENT_DATE,
  f4: MATURITY_DATE,
};
overviewMap[PRODUCT_TERM_ALLOCATED_PENSION_FIXED].closed = {
  f1: ACCOUNT_NUMBER,
  f2: NEXT_PAYMENT_CLOSED,
  f3: DATE_CLOSED,
  f4: MATURITY_DATE,
};

// UnitTrust
overviewMap[PRODUCT_UNIT_TRUST] = {};
overviewMap[PRODUCT_UNIT_TRUST].active = {
  f1: ACCOUNT_NUMBER,
  f2: UNIT_PRICE,
  f3: UNITS,
  f4: BALANCE,
};
overviewMap[PRODUCT_UNIT_TRUST].closed = {
  f1: ACCOUNT_NUMBER,
  f2: UNIT_PRICE_CLOSED,
  f3: UNITS_CLOSED,
  f4: BALANCE_CLOSED,
};
